import { action } from 'cdpro-redux-utils'

export const setWelcomeMessage = action<{ message: string }>('@welcome/SET_MESSAGE')
